/**
 * registry.tsx — the SSOT reference: the full primitive index, the six method packs,
 * and the governance chain. Mirrors egae-component-library §03–04. Read-only.
 */
import { useRegistry } from "../lib/hooks.ts";
import { LoadPips } from "../lib/format.tsx";
import { useT } from "../lib/i18n.tsx";
import { GovernanceChain } from "./home.tsx";

export function RegistryRoute(): JSX.Element {
  const reg = useRegistry();
  const t = useT();
  if (!reg) return <div className="wrap"><p className="mini">{t("common.loading")}</p></div>;
  return (
    <div className="wrap">
      <div className="page-head">
        <div>
          <div className="sec-no">04 / Registry</div>
          <h1 className="page-title">{t("registry.title")}</h1>
        </div>
        <p className="page-desc">Components are method-grounded, never decorative — a primitive only appears when its pack's purpose matches what is being elicited.</p>
      </div>

      <div className="packs">
        {reg.packs.map((p) => (
          <div className="pack" key={p.slug}>
            <div className="pid">{p.methodPackId}</div>
            <div className="pn">{p.name}</div>
            <div className="pp">{p.purpose}</div>
            <div className="pcount">▸ {p.primitiveSlugs.length} primitives · status {p.status}</div>
          </div>
        ))}
      </div>

      <div className="specimen" style={{ marginTop: 28 }}>
        <div className="spec-tab">
          <span className="spec-id"><b>primitive-definition</b> registry · {reg.primitives.length} components</span>
          <span className="spec-fam">SSOT</span>
        </div>
        <div style={{ overflowX: "auto" }}>
          <table className="reg">
            <thead>
              <tr>
                <th>Primitive</th>
                <th className="hide-sm">Method family</th>
                <th>Construct target</th>
                <th>Load</th>
                <th className="hide-sm">Evidence output</th>
              </tr>
            </thead>
            <tbody>
              {reg.primitives.map((p) => (
                <tr key={p.slug}>
                  <td>
                    <div className="pname">{p.name}</div>
                    <div className="purn">{p.primitiveId}</div>
                  </td>
                  <td className="hide-sm"><span className="tag-fam">{p.methodFamily[0]}</span></td>
                  <td>{p.constructTargets.join(" · ")}</td>
                  <td><LoadPips level={p.cognitiveLoadBudget.expectedDemand} /></td>
                  <td className="hide-sm">{p.evidenceOutput.join(", ")}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="page-head" style={{ marginTop: 48 }}>
        <div>
          <div className="sec-no">03 / Governance</div>
          <h2 className="page-title" style={{ fontSize: "clamp(24px,3.5vw,38px)" }}>Six boundaries no component may cross</h2>
        </div>
      </div>
      <GovernanceChain stages={reg.pipeline} />
    </div>
  );
}
